import React, {Component} from 'react';
import Select from 'react-select';
import { Row, Col, Button, ButtonToolbar, ToggleButton, ToggleButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE,
  PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE,
  PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE
} from '../../../reducers/productPageReducer';

import stockItIcon from '../../../assets/img/product-page/STOCKIT-OFF@2x.png';
import priceItIcon from '../../../assets/img/product-page/PRICEIT-OFF@2x.png';
import sellItIcon from '../../../assets/img/product-page/SELLIT-OFF@2x.png';
import GroupHeader from './group-header';

class ObjectiveFilter extends Component {
  selectedObjective() {
    const { filterBox } = this.props;
    const objectives = [];
    if (filterBox.specialStockIt) {
      objectives.push(PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE);
    }
    if (filterBox.specialPriceIt) {
      objectives.push(PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE);
    }
    if (filterBox.specialSellIt) {
      objectives.push(PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE);
    }

    return objectives;
  }

  render() {
    const {
      outlets, filterBox, onObjectiveFilterChange, onOutletFilterChange,
      showStockIt, showPriceIt, showSellIt, fetchingProducts
    } = this.props;
    return (
      <Row className="objectives-filter">
        { (showStockIt || showPriceIt || showSellIt) && (
          <Col lg={12}>
            <GroupHeader>Objectives</GroupHeader>
            <Row>
              <Col lg={8}>
                <ButtonToolbar>
                  {(showStockIt || showPriceIt || showSellIt) && (
                    <ToggleButtonGroup
                      type="checkbox"
                      onChange={onObjectiveFilterChange}
                      value={this.selectedObjective()}
                    >
                      {showStockIt && (
                        <ToggleButton
                          value={PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE}
                          className="objective-filter"
                          disabled={fetchingProducts}
                        >
                          <div>
                            <OverlayTrigger
                              overlay={(
                                <Tooltip className="tooltip" id="tooltip">
                                  click 'STOCK IT' and select an outlet to
                                  view the products eligible for the STOCK IT
                                  objective
                                </Tooltip>
                              )}
                              placement="left"
                            >
                              <Button className="tip" tabIndex="-1">
                                ?
                              </Button>
                            </OverlayTrigger>
                            <img alt="Stock IT" className="filter-image" src={stockItIcon}/>
                            <div>
                              Stock IT
                            </div>
                          </div>
                        </ToggleButton>
                      )}
                      {showPriceIt && (
                        <ToggleButton
                          value={PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE}
                          className="objective-filter"
                          disabled={fetchingProducts}
                        >
                          <div>
                            <OverlayTrigger
                              overlay={(
                                <Tooltip className="tooltip" id="tooltip">
                                  click 'PRICE IT' and select an outlet to
                                  view the products eligible for the PRICE IT
                                  objective
                                </Tooltip>
                              )}
                              placement="left"
                            >
                              <Button className="tip" tabIndex="-1">
                                ?
                              </Button>
                            </OverlayTrigger>
                            <img alt="Price IT" className="filter-image" src={priceItIcon}/>
                            <div>
                              Price IT
                            </div>
                          </div>
                        </ToggleButton>
                      )}
                      { showSellIt && (
                        <ToggleButton
                          value={PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE}
                          className="objective-filter"
                          disabled={fetchingProducts}
                        >
                          <div>
                            <OverlayTrigger
                              overlay={(
                                <Tooltip className="tooltip" id="tooltip">
                                  click 'SELL IT' and select an outlet to view
                                  the products eligible for the SELL IT
                                  incentive
                                </Tooltip>
                              )}
                              placement="left"
                            >
                              <Button className="tip" tabIndex="-1">
                                ?
                              </Button>
                            </OverlayTrigger>
                            <img alt="Sell IT" className="filter-image" src={sellItIcon}/>
                            <div>
                              Sell IT
                            </div>
                          </div>
                        </ToggleButton>
                      )}
                    </ToggleButtonGroup>
                  )}
                </ButtonToolbar>
              </Col>
              <Col lg={4}>
                <label className="color-white">
                  Select an outlet
                </label>
                <Select
                  options={outlets}
                  placeholder=""
                  searchable
                  value={filterBox.selectedOutlet}
                  onChange={onOutletFilterChange}
                  disabled={fetchingProducts}
                />
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    );
  }
}

export default ObjectiveFilter;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/objective-filter.jsx